var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21c5.471 0 10-4.539 10-10 0-5.471-4.539-10-10.01-10C6.529 1 2 5.529 2 11c0 5.461 4.539 10 10 10zm0-1.667c-4.627 0-8.324-3.706-8.324-8.333s3.686-8.333 8.314-8.333S20.324 6.373 20.333 11 16.628 19.333 12 19.333zm-.206-6.304c.49 0 .794-.304.794-.696v-.118c0-.549.314-.892 1-1.343.951-.627 1.627-1.206 1.627-2.373 0-1.637-1.451-2.51-3.118-2.51-1.686 0-2.794.794-3.059 1.696a1.728 1.728 0 00-.088.49.67.67 0 00.676.676c.559 0 .647-.304.961-.667.324-.539.794-.863 1.451-.863.892 0 1.471.5 1.471 1.255 0 .667-.412.99-1.265 1.578-.706.49-1.235 1.01-1.235 1.971v.127c0 .52.284.775.784.775zm-.02 2.931c.569 0 1.059-.451 1.059-1.02 0-.578-.48-1.02-1.059-1.02s-1.059.451-1.059 1.02c0 .559.49 1.02 1.059 1.02z"
  })));
}

export default SvgQuestionCircle;